// @flow

import { action, computed, observable } from "mobx";
import Store from "app/stores/Store";
import GlobalSettingsStore from "app/stores/GlobalSettingsStore";

export const MEDIA = {
    AUDIO_AND_VIDEO: "audio+video",
    AUDIO_ONLY: "audio",
    VIDEO_ONLY: "video"
};

class MediaRecorderStore extends Store {
    startedRecordingTime: number;
    ticker: IntervalID;

    @observable recordedFile: ?File;
    @observable isRecorderOpened: boolean = false;
    @observable media: string = MEDIA.AUDIO_AND_VIDEO;
    @observable duration: number = 0.0;
    @observable isRecording: boolean = false;
    @observable record: boolean = false;

    @action.bound
    tick() {
        if (this.isRecording) {
            this.duration = Math.ceil(
                (Date.now() - this.startedRecordingTime) / 1000
            );
            if (this.duration > this.durationLimit) {
                this.stopRecording();
            }
        }
    }

    @action
    setMedia(media: string) {
        if (!this.isRecording) {
            this.media = media;
        }
    }

    @action
    reset() {
        this.recordedFile = null;
        this.duration = 0.0;
        this.isRecording = false;
    }

    @action
    openRecorder() {
        this.isRecorderOpened = true;
        this.reset();
    }

    @action
    closeRecorder() {
        this.isRecorderOpened = false;
    }

    @action
    startedRecording() {
        this.reset();
        this.isRecording = true;
        this.ticker = setInterval(this.tick, 100);
        this.startedRecordingTime = Date.now();
    }

    @action
    stoppedRecording() {
        this.isRecording = false;
        clearInterval(this.ticker);
    }

    @action
    setRecordedFile(file: File) {
        this.recordedFile = file;
    }

    @action
    setDuration(duration: number) {
        this.duration = duration;
    }

    @action
    startRecording() {
        this.record = true;
    }

    @action
    stopRecording() {
        this.record = false;
    }

    @computed
    get durationLimit() {
        if (this.media === MEDIA.AUDIO_ONLY) {
            return GlobalSettingsStore.mediaRecordingAudioDurationLimit;
        } else {
            return GlobalSettingsStore.mediaRecordingVideoDurationLimit;
        }
    }
}

export default new MediaRecorderStore();



// WEBPACK FOOTER //
// ./src/app/stores/MediaRecorderStore.js